/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ArgosFlexbox from "../../../../../../components/Containers/ArgosFlexbox";
import ArgosErrorMessage from "../../../../../../components/ErrorMessage/ArgosErrorMessage";
import Loader from "../../../../../../components/Loader/Loader";
import { RightPanelPlots } from "./RightPanelPlots";


interface ICameraPerformanceProps {
  isLoadingPlot: boolean
  isError: boolean
  plotData: any
  fovAndBoresightCameraValues: any
}

const CameraPerformanceSection = (props: ICameraPerformanceProps) => {
  return(
  <ArgosFlexbox style={{width: "100%"}} vertical>
  <Loader isLoading={props?.isLoadingPlot}>
    {props?.isError ? <ArgosErrorMessage/> : <RightPanelPlots data={props?.plotData} fovAndBoresightCameraValues={props?.fovAndBoresightCameraValues}/>}
  </Loader>
</ArgosFlexbox>)
}
export default CameraPerformanceSection;